import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getApiDataRequest, getResultData, performApiRequest } from '../redux/apiData';
import withMatch from '@/hocs/withMatch';
import { updateModalOpenState, clearModalState } from '../redux/modal';
import ProjectCard from './ProjectCard';
import ProjectBio from './ProjectBio';
import BBCode from './shared/richText/BBCode';
import Slider from './shared/ui/Slider';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import { shadows, textStyles, colorPalette } from '../styles/styleGuide';
import { fromBreakpoint, toBreakpoint } from '../styles/breakpoints';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    request: getApiDataRequest(state.apiData, 'getProjectShowcase', {
      projectSlug: String(ownProps.projectSlug)
    }),
    project: getResultData(state.apiData, 'getProjectShowcase', {
      projectSlug: String(ownProps.projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getProject: function getProject(projectSlug) {
      dispatch(performApiRequest('getProjectShowcase', {
        projectSlug: projectSlug
      }));
    },
    closeModal: function closeModal(projectSlug) {
      var _ownProps$router;
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(getLinkFromPageObject({
        projectSlug: projectSlug,
        env: 'open'
      })));
    }
  };
};
var ProjectModal = /*#__PURE__*/function (_Component) {
  function ProjectModal() {
    _classCallCheck(this, ProjectModal);
    return _callSuper(this, ProjectModal, arguments);
  }
  _inherits(ProjectModal, _Component);
  return _createClass(ProjectModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.fetchData(this.props);
    }
  }, {
    key: "fetchData",
    value: function fetchData(props) {
      var project = props.project,
        request = props.request,
        getProject = props.getProject,
        projectSlug = props.projectSlug;
      if (!project && (!request || request && request.networkStatus !== 'loading')) {
        getProject(projectSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        project = _this$props.project,
        projectSlug = _this$props.projectSlug,
        closeModal = _this$props.closeModal;
      return project ? __jsx(Container, {
        "data-id": "components_ProjectModal_Container"
      }, __jsx(TopContainer, {
        "data-id": "components_ProjectModal_TopContainer"
      }, __jsx(Slider, {
        heroes: project.media,
        showBullets: false,
        showPrimaryArrows: false,
        showSecondaryArrows: true,
        heightRatio: 664 / 1180,
        currentIndex: 0,
        "data-id": "components_ProjectModal_Slider"
      }), __jsx(Content, {
        "data-id": "components_ProjectModal_Content"
      }, __jsx(TitleContainer, {
        "data-id": "components_ProjectModal_TitleContainer"
      }, __jsx(Title, {
        color: colorPalette.orange,
        "data-id": "components_ProjectModal_Title"
      }, project.title)), __jsx(ProjectBio, _extends({}, project.bio, {
        projectSlug: project.projectSlug,
        "data-id": "components_ProjectModal_ProjectBio"
      })), __jsx(Description, {
        "data-id": "components_ProjectModal_Description"
      }, __jsx(BBCode, {
        content: project.content,
        "data-id": "components_ProjectModal_BBCode"
      })), __jsx(ButtonPrimary, {
        type: "button",
        label: "Naar de projectwebsite",
        clickHandler: function clickHandler() {
          return closeModal(projectSlug);
        },
        buttonColor: colorPalette.blue,
        "data-id": "components_ProjectModal_ButtonPrimary"
      }))), __jsx(ProjectCardRow, {
        "data-id": "components_ProjectModal_ProjectCardRow"
      }, (project.closestProjects || []).map(function (item) {
        return __jsx(ProjectCard, {
          key: item.slug,
          image: item.image,
          isNewBuild: item.isNewBuild,
          title: item.title,
          description: item.description,
          slug: item.slug,
          "data-id": "components_ProjectModal_ProjectCard"
        });
      }))) : null;
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(ProjectModal));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0;\n  padding-left: 20rem;\n  padding-right: 20rem;\n"])));
var TopContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: #fff;\n  padding-bottom: 60rem;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 40rem;\n  ", ";\n\n  ", ";\n"])), shadows.boxPrimary, fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-bottom: 80rem;\n  "]))));
var TitleContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
var ProjectCardRow = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -10rem;\n  margin-right: -10rem;\n  justify-content: space-between;\n  padding: 0 10rem;\n\n  > div {\n    ", ";\n\n    ", ";\n  }\n"])), fromBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      width: calc( ((1/2) * 100%) - 10rem );\n    "]))), fromBreakpoint.lg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n    "]))));
var Title = styled.h1(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"])), textStyles.pageTitle, function (props) {
  return props.color;
}, toBreakpoint.md(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n    margin-top: 40rem;\n  "]))), fromBreakpoint.md(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    margin-top: 60rem;\n  "]))));
var Description = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin-bottom: 45rem;\n"])));